var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "room-setting-chat-component p-5" }, [
    _c("div", { staticClass: "room-setting-content-box" }, [
      _c("h6", { staticClass: "room-setting-content-title" }, [
        _vm._v(_vm._s(_vm.$t("setting.etc.language.title"))),
      ]),
      _c("div", { staticClass: "room-setting-content-text-box" }, [
        _c("p", { staticClass: "room-setting-content-text" }, [
          _vm._v(_vm._s(_vm.$t("setting.etc.language.explain"))),
        ]),
        _c("p", { staticClass: "room-setting-content-text" }, [
          _vm._v(
            _vm._s(
              _vm.$t("setting.etc.language.list", {
                0: `${_vm.$t("common.ko")}, ${_vm.$t("common.en")}`,
              })
            )
          ),
        ]),
      ]),
      _c("div", { staticClass: "room-setting-input-box" }, [
        _c(
          "label",
          { staticClass: "room-setting-label" },
          [
            _c("GrmSimpleSelect", {
              attrs: {
                value: _vm.$i18n.locale,
                options: [
                  { value: "ko", title: _vm.$t("common.ko") },
                  { value: "en", title: _vm.$t("common.en") },
                ],
              },
              on: { input: (value) => _vm.onChangeLocale(value) },
            }),
          ],
          1
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }